import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, BookOpen } from 'lucide-react';
interface Notification {
  name: string;
  location: string;
  action: string;
}
const notifications: Notification[] = [{
  name: 'María G.',
  location: 'México',
  action: 'descargó la guía'
}, {
  name: 'Carlos R.',
  location: 'Colombia',
  action: 'se unió'
}, {
  name: 'Ana L.',
  location: 'Argentina',
  action: 'descargó la guía'
}, {
  name: 'Carmen S.',
  location: 'España',
  action: 'se unió'
}, {
  name: 'Luis H.',
  location: 'Perú',
  action: 'descargó la guía'
}];
export function SocialProofPopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const initialDelay = setTimeout(() => setVisible(true), 5000);
    return () => clearTimeout(initialDelay);
  }, [dismissed]);
  useEffect(() => {
    if (!visible || dismissed) return;
    const hideTimer = setTimeout(() => {
      setVisible(false);
      setTimeout(() => {
        if (!dismissed) {
          setCurrentIndex(prev => (prev + 1) % notifications.length);
          setVisible(true);
        }
      }, 10000);
    }, 5000);
    return () => clearTimeout(hideTimer);
  }, [visible, dismissed]);
  if (dismissed) return null;
  const notif = notifications[currentIndex];
  return <AnimatePresence data-id="element-301">
      {visible && <motion.div initial={{
      opacity: 0,
      x: -60
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -60
    }} className="fixed bottom-16 left-3 z-[1500] max-w-[280px]" data-id="element-302">
          <div className="bg-white rounded-lg shadow-lg border border-[#E2E8F0] p-3 flex items-center gap-3" data-id="element-303">
            <div className="w-8 h-8 rounded-full bg-[#EEF2F7] flex items-center justify-center shrink-0" data-id="element-304">
              <BookOpen className="w-4 h-4 text-[#1B3A6B]" data-id="element-305" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-306">
              <p className="text-xs font-bold text-[#1C1C2E]" data-id="element-307">
                {notif.name}{' '}
                <span className="font-normal text-[#8B8BAA]" data-id="element-308">
                  de {notif.location}
                </span>
              </p>
              <p className="text-xs text-[#1B3A6B] font-medium" data-id="element-309">
                Acaba de {notif.action}
              </p>
            </div>
            <button onClick={() => setDismissed(true)} className="text-[#8B8BAA] hover:text-[#1C1C2E]" data-id="element-310">
              <X className="w-3 h-3" data-id="element-311" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}